import React, { useContext } from "react";
import getImagePath from "helpers/get-image-path";
import VariantList from "../variant-list";
import {
  accessoireImg, accessoire, accessoiresSelected, accessoiresList, accessoireImgWrap, 
  accessoireVariants, accessoiresListText, accessoireText, textContainer, 
  accessoireTextContainer, accessoireImgContainer, variantText, variantDescription, 
  accessoiresListSet, accessoireSet, accessoireSetContainer, setTextContainer
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import { Link } from "gatsby";

const accessoires = (props) => {
  const { variants, currentVariant, content } = props;
  const { handle } = useContext(ProductContext);


  return (
    <>
      {content?.accessoiresCategory == "image" &&
        <ul className={`${accessoiresList}`}>
          {variants.map((variant) => <li
            key={variant.id}
            className={`${accessoire} ${currentVariant.id === variant.id ? accessoiresSelected : ""}`}
          >
            <Link to={`/products/${handle}/${variant.handle.current}`} state={{ preserveScroll: true }}>
              <div className={accessoireImgWrap}>
                <img className={accessoireImg} src={getImagePath(variant?.variantIcon)} alt={variant?.variantIcon?.alt} />
              </div>
            </Link>
          </li>)}
        </ul>
      }
      {content?.accessoiresCategory == "text" &&
        <ul className={`${accessoiresListText}`}>
          {variants.map((variant) => <li
            key={variant.id}
            className={`${accessoireText} ${currentVariant.id === variant.id && accessoiresSelected }`}
          >
            <Link to={`/products/${handle}/${variant.handle.current}`} className={accessoireTextContainer} state={{ preserveScroll: true }}>
              <div className={accessoireImgContainer}>
                <img className={accessoireImg} src={getImagePath(variant?.variantIcon)} alt={variant?.variantIcon?.alt} />
              </div>
              <div className={textContainer}>
                <p className={variantText}>{variant?.variantTitle}</p>
                <p dangerouslySetInnerHTML={{ __html: variant?.woodDescription }} className={variantDescription}/>
              </div>
            </Link>
          </li>)}
        </ul>}

      {content?.accessoiresCategory == "set" &&
        <ul className={`${accessoiresListSet}`}>
          {variants.map((variant) => <li
            key={variant.id}
            className={`${accessoireSet} ${currentVariant.id === variant.id ? accessoiresSelected : ""}`}
          >
            <input type="checkbox" onClick={() => console.log(variant)}  className={accessoireSetContainer} />           
            <div className={accessoireImgContainer}>
              <img className={accessoireImg} src={getImagePath(variant?.variantIcon)} alt={variant?.variantIcon?.alt} />
            </div>
            <div className={setTextContainer}>
              <p className={variantText}>{variant?.variantTitle}</p>
            </div>
          </li>)}
        </ul>}
      <VariantList
        variants={[{
          id: currentVariant?.id, image: currentVariant?.variantIcon, handle: currentVariant?.handle?.current
        }]}
        isSelected={false}
        className={accessoireVariants}
      />
    </>);
};

export default accessoires;